import styled from 'styled-components';

export const Container = styled.div`
  margin: 0;
`;

export const Title = styled.b`
  display: block;
  font-size: 16px;
`;

export const Installments = styled.p`
  font-size: 16px;
  line-height: 1.2;
  margin: 0;
`;
